export const vkycStyles = {
  page: "flex h-screen h-[100dvh] max-h-[100dvh] flex-col overflow-hidden bg-[#F4F6F8] font-inter text-[#0F172A]",
  header:
    "z-30 flex shrink-0 items-center justify-between border-b border-[#E6E8EE] bg-white px-6 py-2 sm:px-8 sm:py-2.5 lg:px-14 lg:py-3",
  headerLogo: "h-8 w-[113px] shrink-0 md:h-9 md:w-[127px] lg:h-10 lg:w-[141px]",
  headerEncrypted: "text-[11px] font-medium text-primary md:hidden",
  scroll: "min-h-0 flex-1 overflow-y-auto overflow-x-hidden",
  body: "mx-auto flex w-full max-w-[1328px] flex-col gap-5 px-6 py-6 sm:gap-6 sm:px-8 sm:py-8 lg:gap-8 lg:px-14 lg:py-10",
  hero: "flex flex-col gap-2",
  eyebrow: "text-[11px] font-semibold tracking-[0.8px] text-primary sm:text-xs sm:tracking-[1.2px]",
  heroTitle:
    "text-2xl font-bold leading-8 text-[#0F172A] sm:text-[28px] sm:leading-[38px] lg:text-4xl lg:leading-[50px]",
  heroSubtitle: "text-[13px] leading-[18px] text-[#64748B] sm:text-[15px] sm:leading-5 lg:text-base lg:leading-[22px]",
  compactSteps: "grid grid-cols-2 gap-3 lg:hidden",
  compactStepActive:
    "flex flex-col gap-2 rounded-xl border-[1.5px] border-primary bg-white p-3 sm:rounded-2xl sm:p-4",
  compactStepIdle:
    "flex flex-col gap-2 rounded-xl border border-[#E6E8EE] bg-[#F5F8FF] p-3 sm:rounded-2xl sm:p-4",
  compactStepTop: "flex items-center justify-between",
  compactNumActive:
    "flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-primary text-[11px] font-bold text-white sm:h-7 sm:w-7 sm:text-[13px]",
  compactNumIdle:
    "flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-[#ECF2FF] text-[11px] font-bold text-primary sm:h-7 sm:w-7 sm:text-[13px]",
  compactStepTitle: "text-xs font-semibold text-[#0F172A] sm:text-sm",
  landingGrid: "grid grid-cols-1 gap-4 lg:grid-cols-2 lg:items-stretch lg:gap-6",
  journeyCard:
    "hidden flex-col gap-4 rounded-[20px] border border-[#E6E8EE] bg-white p-6 lg:flex",
  journeyTitle: "text-[13px] font-semibold text-[#64748B]",
  stepActive:
    "flex items-center gap-4 rounded-2xl border-[1.5px] border-primary bg-white p-5",
  stepIdle:
    "flex items-center gap-4 rounded-2xl border border-[#E6E8EE] bg-[#F5F8FF] p-5",
  stepNumActive:
    "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-base font-bold text-white",
  stepNumIdle:
    "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#ECF2FF] text-base font-bold text-primary",
  stepCopy: "min-w-0 flex-1",
  stepTitle: "text-base font-semibold text-[#0F172A]",
  stepDesc: "mt-1 text-[13px] leading-[18px] text-[#64748B]",
  stepBadgeNow:
    "shrink-0 rounded-full bg-[#ECF2FF] px-2.5 py-1 text-[10px] font-semibold text-primary sm:text-[11px]",
  stepBadgeNext:
    "shrink-0 rounded-full bg-[#F5F8FF] px-2.5 py-1 text-[10px] font-semibold text-[#64748B] sm:text-[11px]",
  keepCard:
    "flex flex-col gap-2 rounded-2xl bg-[#F5F8FF] p-5 sm:gap-2.5 sm:rounded-[20px] sm:border sm:border-[#ECF2FF] sm:p-6",
  keepTitle: "text-xs font-semibold text-[#64748B] sm:text-[13px]",
  keepItem: "flex items-center gap-3 rounded-xl bg-white px-3.5 py-3 sm:px-[18px] sm:py-4",
  keepIcon:
    "flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-[#ECF2FF] text-primary sm:h-9 sm:w-9",
  keepLabel: "text-[13px] font-semibold text-[#0F172A] sm:text-sm",
  keepHint: "mt-0.5 hidden text-xs text-[#64748B] md:block",
  stickyCta:
    "shrink-0 border-t border-[#E6E8EE] bg-white px-6 pb-7 pt-3",
  ctaWrap: "flex flex-col items-center gap-2.5",
  acceptBtn:
    "flex h-12 w-full items-center justify-center rounded-2xl bg-primary px-5 text-[15px] font-semibold text-white shadow-[0_8px_18px_rgba(15,91,241,0.28)] transition hover:bg-[#0a5ae0] disabled:cursor-not-allowed disabled:opacity-60 sm:h-[54px] sm:text-base",
  legalNote: "text-center text-[11px] leading-relaxed text-[#94A3B8] sm:text-xs",
  stage: "flex w-full flex-col gap-5 lg:flex-row lg:items-stretch lg:gap-7",
  contextCard:
    "flex flex-1 flex-col gap-4 rounded-[20px] border border-[#E6E8EE] bg-white p-5 sm:gap-5 sm:p-8",
  contextTitle: "text-2xl font-bold leading-8 text-[#0F172A] sm:text-[32px] sm:leading-10",
  contextBody: "text-sm leading-6 text-[#64748B] sm:text-[15px]",
  tipList: "flex flex-col gap-2.5",
  tipRow: "flex items-center gap-3 rounded-2xl bg-[#F5F8FF] px-3.5 py-3",
  tipNum:
    "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#ECF2FF] text-xs font-semibold text-primary",
  tipText: "text-sm font-medium text-[#0F172A]",
  statusCard:
    "flex w-full flex-col items-center gap-4 rounded-[20px] border border-[#E6E8EE] bg-white p-6 text-center sm:p-10 lg:w-[480px] lg:shrink-0",
  loadingCard:
    "mx-auto flex w-full max-w-[480px] flex-col items-center gap-3 rounded-[20px] border border-[#E6E8EE] bg-white p-10 text-center",
  statusIcon: "flex h-14 w-14 items-center justify-center rounded-full",
  statusTitle: "text-2xl font-bold text-[#0F172A] sm:text-[28px] sm:leading-9",
  statusDescription: "text-sm leading-[22px] text-[#64748B] sm:text-[15px]",
  supportBox:
    "flex w-full flex-col items-center gap-2 rounded-[20px] border border-[#DCE8FE] bg-[#F5F8FF] p-5 text-center",
  supportLabel: "text-[13px] font-medium text-[#64748B]",
  supportLink: "text-sm font-semibold text-primary",
  noteBox: "w-full rounded-xl border px-4 py-3 text-left text-[13px] leading-[18px]",
  noteSuccess: "border-[#BAE3C7] bg-[#F0FCF2] text-[#176638]",
  noteWarning: "border-[#FCE5B2] bg-[#FFF8E7] text-[#915412]",
  noteError: "border-red-200 bg-red-50 text-red-700",
  trustRail: "flex flex-wrap items-center justify-center gap-3",
  trustChip: "rounded-full bg-[#ECF2FF] px-3.5 py-2 text-xs font-medium text-[#64748B]",
  retryBtn:
    "mt-1 inline-flex items-center justify-center rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0a5ae0]",
  spinner: "mx-auto h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent",
};

export const SUPPORT_PHONE = "+91-6364001001";
export const SUPPORT_EMAIL = "support@moneyhop.co";
